import { z } from "zod";

export const vehicleCreatedPayload = z.object({
  registrationNumber: z.string().nullable(),
  vehicleUuid: z.uuid(),
  company: z.uuid(),
  department: z.uuid().nullable(),
});

export type VehicleCreatedPayload = z.infer<typeof vehicleCreatedPayload>;
